import { render, staticRenderFns } from "./BtnAtualizarValoresEmLoteSubItemContrato.vue?vue&type=template&id=d1bf8840"
import script from "./BtnAtualizarValoresEmLoteSubItemContrato.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarValoresEmLoteSubItemContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports